import moment from 'moment-timezone'
import { createSelector } from 'reselect'


const oneOffShareSelector = (state) => state.oneOffShare

const modalVisibleSelector = createSelector(
  oneOffShareSelector,
  ({ modalVisible }) => modalVisible
)

const eventTypeSelector = createSelector(
  oneOffShareSelector,
  ({ eventType }) => eventType
)

const timezoneSelector = createSelector(
  eventTypeSelector,
  ({ timezone }) => timezone
)

const isPollSelector = createSelector(
  eventTypeSelector,
  ({ bookingMethod }) => bookingMethod === 'poll'
)

const emailSelector = createSelector(
  oneOffShareSelector,
  ({ email }) => email
)

const emailSelectedSpotsSelector = createSelector(
  timezoneSelector,
  emailSelector,
  (timezone, { selectedSpots }) => selectedSpots.map((spot) => moment.tz(spot, timezone).format())
)

const groupedSpotsSelector = createSelector(
  timezoneSelector,
  emailSelectedSpotsSelector,
  (timezone, selectedSpots) => {
    const groupedSpots = {}
    selectedSpots.forEach((spot) => {
      const date = moment(spot).tz(timezone).format('YYYY-MM-DD')
      groupedSpots[date] = groupedSpots[date] || []
      groupedSpots[date].push(spot)
    })
    return groupedSpots
  }
)

export {
  isPollSelector,
  timezoneSelector,
  eventTypeSelector,
  modalVisibleSelector,
  groupedSpotsSelector
}
